import React from "react"
import Showcase from "../components/Showcase"
import { View, Button, Text } from "react-ame-components"

class ButtonContainer extends React.Component {
  render() {
    return (
      <View
        padding="small"
        marginBottom="small"
        borderWidth="hairline"
        borderColor="neutral-300"
        borderRadius="small">
        <Text>{this.props.title}</Text>
        <View
          marginTop="extra-small"
          direction="row"
          justify="end">
          <View
            width="auto"
            paddingRight="nano">
            <Button
              variant={this.props.variant}
              onClick={() => console.log("click")}
              label={this.props.variant}
            />
          </View>
          <View width="auto">
            <Button
              variant={this.props.variant}
              onClick={() => console.log("click")}
              label="disabled"
              disabled
            />
          </View>
        </View>
      </View>
    )
  }
}

export class ButtonExample extends React.Component {
  render() {
    return (
      <Showcase
        title="Componente Button"
        description="Veja abaixo os tipos de botões que você pode utilizar">
        <ButtonContainer
          variant="primary"
          title="Botões primários, utilizados para ações mais importantes"
        />
        <ButtonContainer
          variant="secondary"
          title="Botões secundários, utilizados para ações alternativas"
        />
        <ButtonContainer
          variant="global"
          title="Botões globais, utilizados para ações extras menos importantes"
        />
        <ButtonContainer
          variant="text"
          title="Botões de texto, utilizados para ações extras menos importantes"
        />
        <ButtonContainer
          variant="danger"
          title="Botões de perigo, utilizados para ações destrutivas"
        />
      </Showcase>
    )
  }
}
